import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const LingkAdapterWriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="lingkAdapterWriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="lingkAdapterWriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="lingkAdapterWriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="lingkAdapterWriterFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter file format"
        error={errors?.format?.message}
      />
      <FormField
        controlId="lingkAdapterWriterFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.onError?.message}
      >
        <option value="">Select On Error</option>
        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>
      <FormField
        controlId="lingkAdapterWriterFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter connection key"
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="lingkAdapterWriterFormAcceptInvalidCerts"
        label="acceptInvalidCerts"
        name="properties.acceptInvalidCerts"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="lingkAdapterWriterFormRootUrl"
        label="rootUrl"
        name="properties.rootUrl"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Root URL"
        error={errors?.properties?.rootUrl?.message}
      />
      <FormField
        controlId="lingkAdapterWriterFormPath"
        label="path"
        name="properties.path"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Path"
        required
        error={errors?.properties?.path?.message}
      />
      <FormField
        controlId="lingkAdapterWriterFormUrl"
        label="url"
        name="properties.url"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter URL"
        error={errors?.properties?.url?.message}
      />
      <FormField
        controlId="lingkAdapterWriterFormSecret"
        label="secret"
        name="properties.secret"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter Secret"
        error={errors?.properties?.secret?.message}
      />
      <FormField
        controlId="lingkAdapterWriterFormSleepInMilliSeconds"
        label="sleepInMilliSeconds"
        name="properties.sleepInMilliSeconds"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="number"
        placeholder="Enter Sleep In MilliSeconds"
        error={errors?.properties?.sleepInMilliSeconds?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default LingkAdapterWriterForm;
